import { render } from "./ExamMark.vue?vue&type=template&id=469d45a4"
import script from "./ExamMark.vue?vue&type=script&lang=js"
export * from "./ExamMark.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__